import React from 'react'
import {
  ThemeProvider,
  CssBaseline,
  Container,
  Box,
  Typography,
  Paper,
} from '@mui/material'
import { theme } from './theme'
import { SocialPostGenerator } from './SocialMediaGenerator'
import { filmmakersTemplates } from './templates'
import { FilmIcon } from 'lucide-react'

export function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box
        sx={{
          width: '100%',
          minHeight: '100vh',
          backgroundColor: '#F5F5F7',
          py: 6,
          px: 3,
        }}
      >
        <Container maxWidth="xl">
          <Box
            sx={{
              textAlign: 'center',
              mb: 6,
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 1.5,
                mb: 2,
              }}
            >
              <FilmIcon size={32} color="#F26419" />
              <Typography
                variant="h1"
                sx={{
                  fontFamily: "'Playfair Display', serif",
                  color: '#0E0E11',
                  fontSize: {
                    xs: '2rem',
                    md: '3rem',
                  },
                  fontWeight: 600,
                }}
              >
                filmmakers.io
              </Typography>
            </Box>
            <Typography
              sx={{
                fontFamily: "'Funnel Sans', sans-serif",
                color: '#2C2C30',
                fontSize: {
                  xs: '1rem',
                  md: '1.125rem',
                },
                maxWidth: '800px',
                mx: 'auto',
              }}
            >
              Create beautiful cinematic social media posts in three easy steps:
              choose a template, select format, and customize your content.
            </Typography>
          </Box>
          <SocialPostGenerator
            templates={filmmakersTemplates}
            initialQuote="The journey of a thousand miles begins with a single step."
            initialAuthor="Lao Tzu"
          />
          <Paper
            elevation={0}
            sx={{
              mt: 8,
              p: 4,
              backgroundColor: '#FFFFFF',
              borderRadius: '16px',
              border: '1px solid #E0E0E0',
            }}
          >
            <Typography
              variant="h2"
              sx={{
                fontFamily: "'Playfair Display', serif",
                color: '#0E0E11',
                fontSize: {
                  xs: '1.75rem',
                  md: '2.25rem',
                },
                mb: 4,
              }}
            >
              How It Works
            </Typography>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 3,
              }}
            >
              <Box>
                <Typography
                  sx={{
                    fontFamily: "'Funnel Sans', sans-serif",
                    color: '#F26419',
                    fontSize: '1rem',
                    fontWeight: 600,
                    textTransform: 'uppercase',
                    letterSpacing: '0.05em',
                    mb: 1,
                  }}
                >
                  Step 1: Choose Template
                </Typography>
                <Typography
                  sx={{
                    fontFamily: "'Funnel Sans', sans-serif",
                    color: '#2C2C30',
                    fontSize: '0.95rem',
                    lineHeight: 1.6,
                  }}
                >
                  Select from 6 professionally designed templates, each with a
                  unique cinematic aesthetic tailored for filmmakers.
                </Typography>
              </Box>
              <Box>
                <Typography
                  sx={{
                    fontFamily: "'Funnel Sans', sans-serif",
                    color: '#F26419',
                    fontSize: '1rem',
                    fontWeight: 600,
                    textTransform: 'uppercase',
                    letterSpacing: '0.05em',
                    mb: 1,
                  }}
                >
                  Step 2: Select Format
                </Typography>
                <Typography
                  sx={{
                    fontFamily: "'Funnel Sans', sans-serif",
                    color: '#2C2C30',
                    fontSize: '0.95rem',
                    lineHeight: 1.6,
                  }}
                >
                  Choose between Square (1080x1080), Portrait (1080x1350), or
                  Story (1080x1920) format to match your platform.
                </Typography>
              </Box>
              <Box>
                <Typography
                  sx={{
                    fontFamily: "'Funnel Sans', sans-serif",
                    color: '#F26419',
                    fontSize: '1rem',
                    fontWeight: 600,
                    textTransform: 'uppercase',
                    letterSpacing: '0.05em',
                    mb: 1,
                  }}
                >
                  Step 3: Customize & Export
                </Typography>
                <Typography
                  sx={{
                    fontFamily: "'Funnel Sans', sans-serif",
                    color: '#2C2C30',
                    fontSize: '0.95rem',
                    lineHeight: 1.6,
                  }}
                >
                  Add your quote, author, and optionally upload a custom image.
                  See a live preview and export when ready to share your story.
                </Typography>
              </Box>
            </Box>
          </Paper>
        </Container>
      </Box>
    </ThemeProvider>
  )
}

export default App
